module.exports = __webpack_public_path__ + "static/media/10.b60d5626.jpg";